import { useTranslation } from 'react-i18next';

import { useModal } from 'Store/modal';

const useCloseModalRestriction = () => {
  const { t } = useTranslation('live-account');
  const { onOpenModal, onResetModal } = useModal();

  const onCloseRestriction = ({ submit }) => {
    onOpenModal({
      width: '400px',
      isOpen: true,
      type: 'cancel',
      title: t('cancelModalTitle'),
      contentDescription: t('cancelModalDescription'),
      showPrimaryButton: true,
      showSecondaryButton: true,
      primaryButtonText: t('cancelModalConfirmButton'),
      secondaryButtonText: t('cancelModalExitButton'),
      onClickPrimaryButton: () => {
        submit();
        onResetModal();
      },
    });
  };

  return { onCloseRestriction };
};

export default useCloseModalRestriction;